const generateProductGraphQlQuery = (itemNumber, warehouseNumber, clientId, locale, customProperties = {}) => {
  const includeEcoFeeData = (customProperties == null ? void 0 : customProperties.includeEcoFeeData) ?? false;
  let ecoFeeCatalogData = "";
  let ecoFeeChildCatalogData = "";
  if (includeEcoFeeData) {
    ecoFeeCatalogData = `linkFeePrices {
                                key
                                fees {
                                    feeCategory
                                    includeInPrice
                                    excludeFromPrice
                                }
                            }`;
    ecoFeeChildCatalogData = `
            linkFeeEligible
            ${ecoFeeCatalogData}
        `;
  }
  const requestData = {
    query: `
            query {
                products(
                    itemNumbers: ${JSON.stringify(itemNumber)},
                    clientId: "${clientId}",
                    locale: ${JSON.stringify(locale)},
                    warehouseNumber: "${warehouseNumber}"
                ) {
                    catalogData {
                        itemNumber
                        itemId
                        published
                        locale
                        buyable
                        programTypes
                        priceData {
                            price
                            listPrice
                        }
                        attributes {
                            key
                            value
                            type
                            pills
                            identifier
                        }
                        description {
                            shortDescription
                            longDescription
                            marketingContent
                            auxDescription1
                            auxDescription2
                            marketingStatement
                            promotionalStatement
                            popupStatement
                        }
                        additionalFieldData {
                            rating
                            numberOfRating
                            dispPriceInCartOnly
                            eligibleForReviews
                            fsa
                            chdIndicator
                            linkFeeEligible
                            membershipReqd
                            productClassType
                            disponZeroInv
                            backOrderableType
                            backOrderQuantity
                            maxItemOrderQty
                            minItemOrderQty
                            ${ecoFeeCatalogData}
                        }
                        fieldData {
                            mfPartNumber
                            mfName
                            addedDate
                            startDate
                            endDate
                            comparable
                            swatchable
                            imageName
                            variableWeight
                        }
                    }
                    fulfillmentData {
                        itemNumber
                        warehouseNumber
                        clientId
                        channel
                        currency
                        price
                        linkFee
                        listPrice
                        field1Data {
                            replacedItem
                            replacementType
                        }
                    }
                    childData {
                        catalogData {
                            itemNumber
                            buyable
                            published
                            parentId
                            programTypes
                            additionalFieldData {
                                membershipReqd
                                fsa
                                chdIndicator
                                disponZeroInv
                                backOrderableType
                                backOrderQuantity
                                rating
                                numberOfRating
                                ${ecoFeeChildCatalogData}
                            }
                            attributes {
                                key
                                value
                                type
                                pills
                                identifier
                                swatchImage
                            }
                            fieldData {
                                mfPartNumber
                                mfName
                                addedDate
                                startDate
                                endDate
                                comparable
                                swatchable
                                imageName
                                variableWeight
                            }
                            priceData {
                                price
                                listPrice
                            }
                        }
                        fulfillmentData {
                            itemNumber
                            warehouseNumber
                            clientId
                            channel
                            currency
                            price
                            linkFee
                            listPrice
                            discounts {
                                promoAmount
                                promoType
                                promoStartDate
                                promoEndDate
                                maximumCount
                            }
                            shippingInfo {
                                unitOfMeasure
                                factor
                                externalCarrier
                                fulfillmentMethods
                                carrierServices
                            }
                            field1Data {
                                replacedItem
                                replacementType
                            }
                        }
                    }
                }
            }
        `,
    variables: {}
  };
  return requestData;
};
export {
  generateProductGraphQlQuery
};
